import { MouseEventHandler } from 'react';
import styled from 'styled-components';
import CheckMarkIcon from '../../assets/check-mark-icon.svg?react';

export const Tile = styled.div<{ $thinTopPadding?: boolean; $hidden?: boolean }>`
  display: ${(props) => (props.$hidden ? 'none' : 'flex')};
  flex-direction: column;
  gap: 20px;
  margin: 15px 0;
  background-color: var(--color-background);
  padding: ${(props) => (props.$thinTopPadding ? '3px' : '')} 10px;
  border-radius: 15px;
  box-shadow: 0 0 10px 10px var(--color-tile-shadow);
  width: calc(90%);
`;
export const CheckMarkButton = ({
  checked,
  onClick,
  isPurple,
}: {
  checked: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  isPurple?: boolean;
}) => {
  return (
    <CheckMarkButtonWrapper $checked={checked} onClick={onClick} $isPurple={isPurple} $disabled={!onClick}>
      <CheckMarkWrapper>
        <CheckMarkIcon />
      </CheckMarkWrapper>
    </CheckMarkButtonWrapper>
  );
};
const CheckMarkButtonWrapper = styled.button<{
  $checked: boolean;
  $isPurple?: boolean;
  $disabled?: boolean;
}>`
  border: none;
  border-radius: 50px;
  padding: 6px 6px;
  box-shadow: ${(props) =>
    props.$checked ? '2px 2px 2px hsla(0, 0%, 0%, 0.15), 0 1px 2px hsla(0, 0%, 0%, 0.15)' : 'none'};
  background-color: ${(props) =>
    props.$checked
      ? `var(${props.$isPurple ? '--color-checkmark-song-purple' : '--color-checkmark-song'})`
      : 'var(--color-background-button-disabled)'};
  width: fit-content;
  height: fit-content;
  cursor: ${(props) => (props.$disabled ? 'inherit' : 'pointer')};
`;
const CheckMarkWrapper = styled.div`
  width: 16px;
  height: 16px;
  padding-top: 2px;
  fill: var(--color-background);
`;
export const Divider = styled.hr`
  display: block;
  height: 1px;
  width: 100%;
  border: 0;
  border-top: 1px solid var(--color-divider);
  margin-bottom: 4px;
  padding: 0;
`;
